// File: src/formData/donationFilterSchema.js

export const donationFilterSchema = {
  fields: [
   {
      type: 'group',
      name: 'row1',
      children: [
        {
          name: 'donationDate',
          label: 'Donation Date',
          type: 'date',
          placeholder: 'Select',
          required: false,
        },
        {
          name: 'paymentModifier',
          label: 'Payment Modifier',
          type: 'select',
          placeholder: 'Select',
          required: false,
          options: [
            { label: 'Match Fee', value: 'match_fee' },
            { label: 'Standard Fee', value: 'standard_fee' },
            // add more as needed
          ],
        },
      ],
    },
    {
      type: 'group',
      name: 'row2',
      children: [
        {
          name: 'paymentMethod',
          label: 'Payment Method',
          type: 'select',
          placeholder: 'Select',
          required: false,
          options: [
            { label: 'AID PAY CC', value: 'aid_pay_cc' },
            { label: 'AID PAY ACH', value: 'aid_pay_ach' },
            { label: 'Web-Payment', value: 'web_payment' },
            { label: 'Terminal', value: 'terminal' },
            // add more as needed
          ],
        },
        {
          name: 'paymentStatus',
          label: 'Payment Status',
          type: 'select',
          placeholder: 'Select',
          required: false,
          options: [
            { label: 'Completed', value: 'completed' },
            { label: 'Pending', value: 'pending' },
            { label: 'Refunded', value: 'refunded' },
            { label: 'Processing', value: 'processing' },
            { label: 'Failed', value: 'failed' },
            { label: 'Rejected', value: 'rejected' },
          ],
        },
      ],
    },
  ],
  buttons: [
    {
      label: 'Clear Filter',
      action: 'clear',
      type: 'button',
      className: 'btn-back',
    },
    {
      label: 'Apply',
      action: 'apply',
      type: 'button',
      className: 'btn-next',
    },
  ],
};
